/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import ISectionApiClient from './contracts'
import { ISectionArticleList } from '../SectionStateManager/contracts'
import { injectable } from 'inversify'

@injectable()
export class MockSectionApiClient implements ISectionApiClient {
	sectionArticleList: ISectionArticleList
	/**
	 *
	 */
	constructor() {
		this.sectionArticleList = {
			total: 12,
			items: [
				{
					sectionArticleId: 1,
					sectionArticleName: 'MDS Scheduling Management Tools',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/1',
				},
				{
					sectionArticleId: 2,
					sectionArticleName: 'ICD-10 Clinical Categories Lookup Tool',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/2',
				},
				{
					sectionArticleId: 3,
					sectionArticleName: 'ICD-10 NTA Comorbidity Lookup Tool',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/3',
				},
				{
					sectionArticleId: 4,
					sectionArticleName: 'MDS Transmission Watch',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/4',
				},
				{
					sectionArticleId: 5,
					sectionArticleName: 'MDS Transmission Enterprise Report',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/5',
				},
				{
					sectionArticleId: 6,
					sectionArticleName: 'Correct Suspended Assessments',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/6',
				},
				{
					sectionArticleId: 7,
					sectionArticleName: 'MDS Quality Scheduling Management',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/7',
				},
				{
					sectionArticleId: 8,
					sectionArticleName: 'MDS Quality Clinical Categories Lookup',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/8',
				},
				{
					sectionArticleId: 9,
					sectionArticleName: 'MDS Quality Comorbidity Lookup',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/9',
				},
				{
					sectionArticleId: 10,
					sectionArticleName: 'MDS Quality Transmission Watch',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/10',
				},
				{
					sectionArticleId: 11,
					sectionArticleName: 'MDS Quality Transmission Enterprise',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/11',
				},
				{
					sectionArticleId: 12,
					sectionArticleName: 'MDS Quality Suspended Assessments',
					productCode: 'Care Watch',
					sectionName: 'MDS',
					sectionArticlePath: '/content/12',
				},
			],
		} as ISectionArticleList
	}

	getSectionArticles(productCode: string, sectionName: string): Promise<ISectionArticleList> {
		return new Promise<ISectionArticleList>(resolve => {
			setTimeout(() => resolve(this.sectionArticleList), 100)
		})
	}
}
